import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=59b4f5fe&scoped=true"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"
import style0 from "./signup.vue?vue&type=style&index=0&id=59b4f5fe&prod&lang=css"
import style1 from "./signup.vue?vue&type=style&index=1&id=59b4f5fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b4f5fe",
  null
  
)

export default component.exports